module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_150_180.566ed29e.png";